import { MinusCircleOutlined } from '@ant-design/icons'
import { Form, Input, Col, Row, Button } from 'antd'
import { FC, useEffect } from 'react'
import { CustomFormInstance } from '../../../../types'
import { MachineForm, MachineNames } from '../types'
import { ValidQuestionKeys } from '../../../../hooks/useGerateQuestions'

type Props = {
    form: CustomFormInstance<MachineForm>
    setContentBasedItemsToReview?: React.Dispatch<
        React.SetStateAction<ValidQuestionKeys[]>
    >
}

const CustomBackgroundOfInnovation: FC<Props> = ({
    form,
    setContentBasedItemsToReview,
}) => {
    useEffect(() => {
        if (!setContentBasedItemsToReview) return

        // Watch for changes in customCharacteristic field
        const customCharacteristics = form.getFieldValue([
            'backgroundInvention',
            'customCharacteristic',
        ])

        // If no characteristics added or empty array, notify patent professional
        if (!customCharacteristics || customCharacteristics.length === 0) {
            setContentBasedItemsToReview((prev) => {
                if (
                    !prev.includes(
                        MachineNames.customBackgroundOfInvention as ValidQuestionKeys
                    )
                ) {
                    return [
                        ...prev,
                        MachineNames.customBackgroundOfInvention as ValidQuestionKeys,
                    ]
                }
                return prev
            })
        } else {
            // Remove from review if user has added characteristics
            setContentBasedItemsToReview((prev) =>
                prev.filter(
                    (item) => item !== MachineNames.customBackgroundOfInvention
                )
            )
        }
    }, [
        form.getFieldValue(['backgroundInvention', 'customCharacteristic']),
        setContentBasedItemsToReview,
    ])
    return (
        <>
            <Form.List name={['backgroundInvention', 'customCharacteristic']}>
                {(fields, { add, remove }, errors) => (
                    <>
                        {fields.map((field) => (
                            <Form.Item
                                shouldUpdate={(prevValues, curValues) =>
                                    prevValues.commonName?.notSet !==
                                    curValues.commonName?.notSet
                                }
                                key={field.key}
                            >
                                <Row gutter={[12, 0]}>
                                    <Col span={22}>
                                        <Form.Item
                                            {...field}
                                            name={[field.name]}
                                            fieldKey={[
                                                field.fieldKey as number,
                                            ]}
                                            hasFeedback
                                            rules={[
                                                {
                                                    required:
                                                        !form.getFieldValue([
                                                            'backgroundInvention',
                                                            'notSet',
                                                        ]) ?? true,
                                                    message:
                                                        'Characteristic is required',
                                                },
                                            ]}
                                        >
                                            <Input type="text" />
                                        </Form.Item>
                                    </Col>
                                    <Col
                                        style={{
                                            textAlign: 'center',
                                            paddingTop: '0.4rem',
                                        }}
                                        span={2}
                                    >
                                        {fields.length > 0 ? (
                                            <MinusCircleOutlined
                                                className="dynamic-delete-button"
                                                onClick={() =>
                                                    remove(field.name)
                                                }
                                                style={{
                                                    color: '#f00',
                                                    fontSize: '1.2rem',
                                                }}
                                            />
                                        ) : null}
                                    </Col>
                                </Row>
                            </Form.Item>
                        ))}

                        <Form.ErrorList errors={errors.errors} />
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block>
                                Add custom characteristic
                            </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>
        </>
    )
}

export default CustomBackgroundOfInnovation
